module.exports = __webpack_public_path__ + "assets/img/17_1033_big.d4d6fbcd.jpg";